import { currencyFormatter } from '@/helpers/currencyFormatter';
import { Alert, Box } from '@palmetto/palmetto-components';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';

import { HVACProductPricingResponse } from 'types';

export function FormResultSection({ data }: { data: HVACProductPricingResponse[] }) {
  const { values: formValues, setFieldValue } = useFormikContext<any>();

  const selectedProduct = useMemo(() => {
    if (data.length === 0 || !formValues.term || !formValues.rate) {
      return undefined;
    }
    const matchingProduct = data.find(
      (item) => item.term === parseInt(formValues.term) && item.escalationRate === parseFloat(formValues.rate),
    );

    setFieldValue('productId', matchingProduct?.productId);

    return matchingProduct;
  }, [data, formValues, setFieldValue]);

  return (
    <Box
      style={{
        margin: '1em 0',
      }}
      childGap="md"
    >
      {formValues.term === undefined ||
      formValues.term === '' ||
      formValues.rate === undefined ||
      formValues.rate === '' ? (
        <Alert message="Please select a term and an escalator rate to see the monthly payment." />
      ) : null}
      {selectedProduct?.isEstimate ? (
        <Alert variant="info" message="This is an estimate and may change based on system design." hasIcon />
      ) : null}
      {selectedProduct ? (
        <Box>
          <Box
            style={{
              fontSize: '12pt',
            }}
          >
            Year 1 Monthly Payment
          </Box>
          <Box
            style={{
              fontSize: '24pt',
            }}
          >
            {currencyFormatter.format(selectedProduct.monthlyPayments[0]?.totalMonthlyPayment || 0)}/mo
          </Box>
          <Box
            style={{
              fontSize: '12pt',
              fontWeight: 'medium',
            }}
          >
            Customer Payment
          </Box>
        </Box>
      ) : null}
    </Box>
  );
}
